import React from 'react';
import { Navigate } from 'react-router-dom';
import { clearAuthSession, getAuthToken, isTokenExpired, rememberAuthReturnPath } from '../services/auth';

const ProtectedRoute = ({ children }) => {
  const token = getAuthToken();
  if (!token || isTokenExpired(token)) {
    rememberAuthReturnPath();
    clearAuthSession();
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
